import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { Role } from '../../enums/role';
import { Permission } from '../../enums/permission';

@jsonObject
export class MeResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly username!: string;

  @jsonMember(String)
  public readonly email!: string;

  @jsonMember(String)
  public readonly firstName?: Nillable<string>;

  @jsonMember(String)
  public readonly lastName?: Nillable<string>;

  @jsonMember(String)
  public readonly displayName!: string;

  @jsonMember(String)
  public readonly avatar: Nillable<string>;

  @jsonArrayMember(String)
  public readonly roles!: Role[];

  @jsonArrayMember(String)
  public readonly permissions!: Permission[];
}
